module.exports = __webpack_public_path__ + "img/block-375.fc8802c6.jpg";